import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import {
  VStack,
  HStack,
  Box,
} from "@whoosh/design-system/src/components/primitive";

/**
 *
 * This is a loader set up to look like on of our editable sections with an icon/title/dropdown.
 *
 * It should be used when we are loading one of our editable sections
 */
export const EditSectionSkeletonLoader = () => {
  return (
    <VStack padding={5} gap={5} backgroundColor="surface-primary" marginTop={2}>
      <HStack alignItems="center" gap={3}>
        <Box
          backgroundColor="surface-main-primary-subtlest"
          width={24}
          height={24}
          justifyContent="center"
          alignItems="center"
          style={{ borderRadius: 4 }}
        >
          <SkeletonLoader width={16} height={16} />
        </Box>
        <SkeletonLoader borderRadius="2" width={150} height={16} />
      </HStack>
      <VStack flex={1}>
        <SkeletonLoader borderRadius="2" width={341} height={48} />
      </VStack>
    </VStack>
  );
};
